import $ from 'jquery';
import _ from 'lodash';
import { greenImageSize, measureFromEnum, rotationSetType, rotationType, usageType } from './constants';
import { createPin } from './createPins';
import { distanceCalc } from './visageHelpers';
import { store } from '../../../redux/store';
import { setDirtyEditPinsFlagReduxStateAction } from 'redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer';
import moment from "moment";
import { datacontext } from './services'
import {
    COMMON_SERVICES
} from '../../../redux/reduxToolkitServices/_commonServices/commonServices';
import { setPinMovementDetectorAction, setPinsEditModeReduxStateAction } from 'redux/reduxToolkitServices/_commonReducers/commonReducers';
import { PINS_GLOBAL_STATE } from 'globalStore/globalStore';

let draggingElement = 0; // GLobal Variable
let lastX = null; // GLobal Variable
let lastY = null; // GLobal Variable
let dragX = null; // GLobal Variable
let dragY = null; // GLobal Variable
var logActions = []; // GLobal Variable
export var UpdatedApproachViews = []; // GLobal Variable for Updated Hole Data
let isUserReadOnly = false // Observable -- datacontext.isUserReadOnly
let activeMarker = ""
export let pinMovementDetectorState = false

export let pinTracker = {
   isPinTracked:false
}
export let selectedPin = {};
 
 export const activeRotation = () => {
   const state = store.getState();
   const greensDescriptions = state.commonReducers.greensWithPinPlacementStateData;
    if (greensDescriptions && greensDescriptions.RotationSets.length !== 0) {
       var active = _.filter(_.flatMapDeep(greensDescriptions.RotationSets, 'Rotations'), 'Active');
       if (active.length === 1) {
          return active[0];
       }
    }
    return null;
 }

export function getParentRotationSetForMarker(markerData,greensDescriptions) {
    let rotationSet = _.find(greensDescriptions && greensDescriptions?.RotationSets, function (val) {
       return _.filter(val.Rotations, { 'Marker': markerData?.toString() }).length > 0;
    });
    return rotationSet
 };

export function addClassSvg(el, cl) {
    var curr = el.getAttribute("class");
    if (curr === null || curr.indexOf(cl) === -1) {
       el.setAttribute("class", _([el.getAttribute("class"), cl]).join(' '));
    }
}

export function setAttributes(el, attrs) {
    for (var key in attrs) {
       el.setAttributeNS(null, key, attrs[key]);
    }
}

export function getHoleForElement(el, greensDescriptions) {
    var svgElement = getSvg(el);
    if (svgElement !== undefined && svgElement !== null) {
       var holeNumber = Number(svgElement.getAttribute('data-hole'));
       var holeInfo = (_.filter(greensDescriptions.ApproachViews, { 'Hole': holeNumber }))[0];
       return holeInfo;
    }
}

export function getHoleInfoForElement(el) {
   var svgElement = getSvg(el);
   if (svgElement !== undefined && svgElement !== null) {
      var holeNumber = Number(svgElement.getAttribute('data-hole'));
     // var holeInfo = (_.filter(greensDescriptions.ApproachViews, { 'Hole': holeNumber }))[0];
      return holeNumber;
   }
}

export function pinLocation(el,holeData) {
   if(holeData){
      var x = Number(el.getAttribute("origx")) + Number(el.getAttribute("dragx"));
      var y = Number(el.getAttribute("origy")) + Number(el.getAttribute("dragy"));
      var ptWorld = holeData.greenToWorld.transformPoint(x, y);
      return { x: x, y: y, longitude: ptWorld[0], latitude: ptWorld[1] };
   }
}

export function showDistanceToolTip() {
    $("#pinDistanceToolTip").css('visibility', 'visible');
}

export function hideDistanceToolTip() {
    $("#pinDistanceToolTip").css('visibility', 'hidden');
}

export function getSvg(el) {
    if (el !== undefined) return (el.tagName === "svg") ? el : el.ownerSVGElement;
}

export function createDistanceToolTip(viewX, viewY, x, y, holeInfo, rotationName) {
    // Get the contents to be displayed in the div that is used for the tooltip
    
    let divContents = createToolTipText(x, y, holeInfo, rotationName);
    let infoDiv = document.getElementById('pinDistanceToolTip');
    infoDiv.innerHTML = divContents;
    infoDiv.style.left = viewX - 50 + 'px';
    infoDiv.style.top = viewY + 20 + 'px';
    showDistanceToolTip();
}

export function createToolTipText(x, y, holeInfo, rotationName) {

    let state = store.getState()
    let viewMeasureFromReduxState = state.firstReducer.viewMeasureFromReduxState;
    let viewDistanceYards = state.firstReducer.viewDistanceYardsReduxState
    var leftRightPhrase = "";
    var frontBackPhrase = "";
    // Get the cog in Green Coordinate system
    if(holeInfo){
      var cog = _.filter(holeInfo.PoiData, { 'Name': 'CenterOfGreen' })[0];
      var cogArray = holeInfo.viewToGreen.transformPoint(cog.X, cog.Y);
      var cogPoint = { x: cogArray[0], y: cogArray[1] };
      if (x >= holeInfo.left && x <= holeInfo.right && y >= holeInfo.back && y <= holeInfo.front) {
         var isUnitYards = viewDistanceYards;
         var distanceValues = createDistanceMeasurements(x, y, holeInfo);
  
         switch (viewMeasureFromReduxState) {
            case measureFromEnum.frontClosest:
               if (distanceValues.dFromLeft <= distanceValues.dFromRight) {
                  leftRightPhrase = `<br><span>${distanceValues.dFromLeft} ${isUnitYards ? 'yds' : 'm'} from Left</span>`;
               } else {
                  leftRightPhrase = `<br><span>${distanceValues.dFromRight} ${isUnitYards ? 'yds' : 'm'} from Right</span>`;
               }
               frontBackPhrase = `<br><span>${distanceValues.dFromFront} ${isUnitYards ? 'yds' : 'm'} from Front</span>`;
               break;
            case measureFromEnum.closest:
               if (distanceValues.dFromLeft <= distanceValues.dFromRight) {
                  leftRightPhrase = `<br><span>${distanceValues.dFromLeft} ${isUnitYards ? 'yds' : 'm'} from Left</span>`;
               } else {
                  leftRightPhrase = `<br><span>${distanceValues.dFromRight} ${isUnitYards ? 'yds' : 'm'} from Right</span>`;
               }
               if (distanceValues.dFromFront <= distanceValues.dFromBack) {
                  frontBackPhrase = `<br><span>${distanceValues.dFromFront} ${isUnitYards ? 'yds' : 'm'} from Front</span>`;
               } else {
                  frontBackPhrase = `<br><span>${distanceValues.dFromBack} ${isUnitYards ? 'yds' : 'm'} from Back</span>`;
               }
               break;
            case measureFromEnum.frontLeft:
               leftRightPhrase = `<br><span>${distanceValues.dFromLeft} ${isUnitYards ? 'yds' : 'm'} from Left</span>`;
               frontBackPhrase = `<br><span>${distanceValues.dFromFront} ${isUnitYards ? 'yds' : 'm'} from Front</span>`;
               break;
            case measureFromEnum.center:
               leftRightPhrase = `<br><span>${distanceValues.dFromCogHorz} ${isUnitYards ? 'yds' : 'm'} ${(x <= cogPoint.x) ? ' Left' : ' Right'} of Center</span>`;
               frontBackPhrase = `<br><span>${distanceValues.dFromCogVert} ${isUnitYards ? 'yds' : 'm'} ${(y <= cogPoint.y) ? ' Back' : ' Front'} of Center</span>`;
               break;
            default: 
               leftRightPhrase = "";
               frontBackPhrase = "";
         }
      }
  
      var divContents = "<div>"
            + "<span>" + rotationName + "</span>"
            + leftRightPhrase
            + frontBackPhrase
            + "</div>";
  
      return divContents;
    }
   
}

export function createDistanceMeasurements(x, y, holeInfo) {
   let state = store.getState()

   let viewDistanceYards = state.firstReducer.viewDistanceYardsReduxState;
    // Get the cog in Green Coordinate system
    var cog = _.filter(holeInfo.PoiData, { 'Name': 'CenterOfGreen' })[0];
    var cogArray = holeInfo.worldToImage.transformPoint(cog.Longitude, cog.Latitude);
    cogArray = holeInfo.viewToGreen.transformPoint(cogArray[0], cogArray[1]);
    var cogPoint = { x: cogArray[0], y: cogArray[1] };
   
    var pinPointArray = holeInfo.greenToWorld.transformPoint(x, y);
    var pinPoint = { lng: pinPointArray[0], lat: pinPointArray[1] };

    // Get Left point perpendicular to point to measure
    var pinLeftGreen = { x: holeInfo.left, y: y };
    var pinLeftGreenArray = holeInfo.greenToWorld.transformPoint(pinLeftGreen.x, pinLeftGreen.y);
    var pinLeftGreenPoint = { lng: pinLeftGreenArray[0], lat: pinLeftGreenArray[1] };

    // Get Right point perpendicular to point to measure
    var pinRightGreen = { x: holeInfo.right, y: y };
    var pinRightGreenArray = holeInfo.greenToWorld.transformPoint(pinRightGreen.x, pinRightGreen.y);
    var pinRightGreenPoint = { lng: pinRightGreenArray[0], lat: pinRightGreenArray[1] };

    // Get Front point perpendicular to point to measure
    var pinFrontGreen = { x: x, y: holeInfo.front };
    var pinFrontGreenArray = holeInfo.greenToWorld.transformPoint(pinFrontGreen.x, pinFrontGreen.y);
    var pinFrontGreenPoint = { lng: pinFrontGreenArray[0], lat: pinFrontGreenArray[1] };

    // Get Back point perpendicular to point to measure
    var pinBackGreen = { x: x, y: holeInfo.back };
    var pinBackGreenArray = holeInfo.greenToWorld.transformPoint(pinBackGreen.x, pinBackGreen.y);
    var pinBackGreenPoint = { lng: pinBackGreenArray[0], lat: pinBackGreenArray[1] };

    // Get point along vertical line running through the COG that is perpendicular to the point to measure
    var pinCogVertArray = holeInfo.greenToWorld.transformPoint(x, cogPoint.y);
    var pinCogVertPoint = { lng: pinCogVertArray[0], lat: pinCogVertArray[1] };

    // Get point along horizontal line running through the COG that is perpendicular to the point to measure
    var pinCogHorzArray = holeInfo.greenToWorld.transformPoint(cogPoint.x, y);
    var pinCogHorzPoint = { lng: pinCogHorzArray[0], lat: pinCogHorzArray[1] };

    //Get Distance from Left and Front
    var isUnitYards = viewDistanceYards;

    return {
       dDepth: Math.round(distanceCalc.distanceBetweenPoints(pinBackGreenPoint, pinFrontGreenPoint, isUnitYards)),

       dFromCogVert: Math.round(distanceCalc.distanceBetweenPoints(pinPoint, pinCogVertPoint, isUnitYards)),

       dFromCogHorz: Math.round(distanceCalc.distanceBetweenPoints(pinPoint, pinCogHorzPoint, isUnitYards)),

       dFromLeft: Math.round(distanceCalc.distanceBetweenPoints(pinPoint, pinLeftGreenPoint, isUnitYards)),

       dFromRight: Math.round(distanceCalc.distanceBetweenPoints(pinPoint, pinRightGreenPoint, isUnitYards)),

       dFromFront: Math.round(distanceCalc.distanceBetweenPoints(pinPoint, pinFrontGreenPoint, isUnitYards)),

       dFromBack: Math.round(distanceCalc.distanceBetweenPoints(pinPoint, pinBackGreenPoint, isUnitYards))
    };
}

 export function removeSelectedPinMarker() {
   if ((selectedPin !== null) && (selectedPin.circle !== null)) {
      $(selectedPin.circle).remove();
      selectedPin = null;
   }
}

// TODO -- Functionality Need to be integrated
export function moveElement(evt,hole) {
   // sessionStorage.setItem("pinMovementDetectorReduxState",true)
   logAction('Move pins');
   if(evt?.touches){
      let touch = evt?.touches[0];
      let currX = touch.clientX;
      let currY = touch.clientY;

      let dx = currX - lastX;
      let dy = currY - lastY;

      lastX = currX;
      lastY = currY;

      dragX += dx;
      dragY += dy;

      selectedPin.x += dx;
      selectedPin.y += dy;
      
      // TODO -- selectedPin.valueHasMutated();
      if(draggingElement !== 0){
         let holeInfo = getHoleInfoForElement(evt.target);
         // console.log("holeInfo",holeInfo,"Hole",hole)
         if(holeInfo === hole?.Hole){
            let rotationName = draggingElement.getAttributeNS(null, 'rotation-name');
            // createDistanceToolTip(evt.clientX, evt.clientY, selectedPin.x, selectedPin.y, holeInfo, rotationName);
            createDistanceToolTip(touch.clientX, touch.clientY, selectedPin.x, selectedPin.y, hole, rotationName);
         
            // Set the attribute so that it's available for next selection.
            draggingElement.setAttributeNS(null, "dragx", dragX);
            draggingElement.setAttributeNS(null, "dragy", dragY);
         
            // Create the new translation for this pin so that it moves.
            let newLocationTransform = "translate(" + dragX + "," + dragY + ")";
            draggingElement.setAttribute("transform", newLocationTransform);
         }
      }
   }else{
      let currX = evt.clientX;
      let currY = evt.clientY;

      let dx = currX - lastX;
      let dy = currY - lastY;
      lastX = currX;
      lastY = currY;

      dragX += dx;
      dragY += dy;

      selectedPin.x += dx;
      selectedPin.y += dy;
      
      // TODO -- selectedPin.valueHasMutated();
      if(draggingElement !== 0){
         let holeInfo = getHoleInfoForElement(evt.target);
         // console.log("holeInfo",holeInfo,"Hole",hole)
         if(holeInfo === hole?.Hole){
            let rotationName = draggingElement.getAttributeNS(null, 'rotation-name');
            // createDistanceToolTip(evt.clientX, evt.clientY, selectedPin.x, selectedPin.y, holeInfo, rotationName);
            createDistanceToolTip(evt.clientX, evt.clientY, selectedPin.x, selectedPin.y, hole, rotationName);
         
            // Set the attribute so that it's available for next selection.
            draggingElement.setAttributeNS(null, "dragx", dragX);
            draggingElement.setAttributeNS(null, "dragy", dragY);
         
            // Create the new translation for this pin so that it moves.
            let newLocationTransform = "translate(" + dragX + "," + dragY + ")";
            draggingElement.setAttribute("transform", newLocationTransform);
         }
      }
   }
   
}

// TODO -- Functionality Need to be integrated
export function logAction(action) {
   if (logActions.length > 0 && logActions[logActions.length - 1] === action) {
      // We aren't logging the same message repeatedly.
      return;
   }
   logActions.push(action);
};

export function deselectElement(evt,hole) {
   hideDistanceToolTip()

   if (draggingElement !== 0) { 
      // store.dispatch(setDirtyEditPinsFlagReduxStateAction(true))
      // TODO Needs to be integrated later -- dirtyEditPinsFlag(true);
      // store.dispatch(setDirtyEditPinsFlagReduxStateAction(true))
      logAction('Move pins');

      draggingElement.ownerSVGElement.removeEventListener("mousemove", function(evt){
         moveElement(evt,hole)
      },false);
      draggingElement.ownerSVGElement.removeEventListener("mouseup", function(evt) {
         deselectElement(evt,hole)
      }, false);

      updatePin(draggingElement,hole);
      updateElements(draggingElement.ownerSVGElement,hole);
      draggingElement = 0;
   }
}

export const pindetectorHandler = () => {
   const { pinMovementDetectorReduxState } = store.getState().commonReducers;
   if(pinMovementDetectorReduxState === false){
      store.dispatch(setPinMovementDetectorAction(true))
   }
}

 export let selectElement = function(evt,hole) {
   var touch = evt?.touches ? evt?.touches[0] : null;
   var holeInfo = getHoleInfoForElement(evt.target);
   if(holeInfo === hole?.Hole){
   
   draggingElement = evt.currentTarget;
   // Save the current mouse position as the lastX & Y
   if(touch){
      lastX = touch.clientX;
      lastY = touch.clientY;
   } else{
      lastX = evt.clientX
      lastY = evt.clientY;
   }
   

   dragX = parseInt(draggingElement.getAttributeNS(null, "dragx"), 10);
   dragY = parseInt(draggingElement.getAttributeNS(null, "dragy"), 10);

   //OLD -- draggingElement.ownerSVGElement.addEventListener("mousemove", function(evt){
   // Below we have improved code
   // console.log("eventData",evt)
   // window.pinMovementDetectorReduxState = true
   // localStorage.setItem("pinMovementDetectorReduxState",true)
   PINS_GLOBAL_STATE.setdisabledEditButton.set(true);
   PINS_GLOBAL_STATE.setDisplayButton.set(true);
   draggingElement.ownerSVGElement.addEventListener("mousemove", function(evt){
      moveElement(evt,hole);
   }, false);
   draggingElement.ownerSVGElement.addEventListener("mouseup", function(){
      deselectElement(evt,hole);
   }, false);
   draggingElement.ownerSVGElement.addEventListener("touchmove", function(evt){
      moveElement(evt,hole);
   }, false);
   draggingElement.ownerSVGElement.addEventListener("touchend", function(){
      deselectElement(evt,hole);
   }, false);

   // TODO -- Mark element
   removeSelectedPinMarker();  // Remove previous
   var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
   circle.id = "selectedIndicator";
   var cx = Number(draggingElement.getAttributeNS(null, "origx"), 10);
   var cy = Number(draggingElement.getAttributeNS(null, "origy"), 10);
   setAttributes(circle, { cx: cx, cy: cy, r: 11, fill: "purple" });
   draggingElement.insertBefore(circle, draggingElement.firstChild);

   // Save Pins info
   selectedPin = {
      circle: circle,
      x: cx + dragX,
      y: cy + dragY
   };
 }
}

export function pinInTray(el,hole) {
   return (pinLocation(el,hole).x > greenImageSize + 5);
}

export function updatePin(pin,hole) {
   let dataMarker = pin.getAttribute("data-marker");
   let pinToUpdate = _.filter(hole.UpdatedPinData, { 'Name': dataMarker })[0];
   let pinToUpdateData = {...pinToUpdate}
   if (pinInTray(pin,hole)) {
      pinToUpdateData.Latitude = 0;
      pinToUpdateData.Longitude = 0;
      pinToUpdateData.X = 0;
      pinToUpdateData.Y = 0;
   } else {
      let newPinLocation = pinLocation(pin,hole);
      pinToUpdateData.Latitude = newPinLocation.latitude;
      pinToUpdateData.Longitude = newPinLocation.longitude;
      let location = hole.greenToView.transformPoint(newPinLocation.x, newPinLocation.y);
      pinToUpdateData.X = location[0];
      pinToUpdateData.Y = location[1];
   }
   
   hole.UpdatedPinData.splice(hole.UpdatedPinData.findIndex((item) => item.Name === pinToUpdate.Name),1)
   hole.UpdatedPinData.push(pinToUpdateData);
   let holeIndex = UpdatedApproachViews.findIndex((item) => item.Hole === hole.HoleNumber)
   if(holeIndex > -1){
      UpdatedApproachViews.splice(holeIndex,1)
   }
   UpdatedApproachViews.push(hole)
  
};

export function centerOfGreenActive() {
   return activeMarker === "cog"
};

export function pinOutsideImageView(el,hole) {
   var loc = pinLocation(el,hole);
   return (loc.x < 0 || loc.x > greenImageSize || loc.y < 0 || loc.y > greenImageSize);
}

export function moveUnviewablePinsToTray(evt,hole) {
   store.dispatch(setPinsEditModeReduxStateAction(true))
   store.dispatch(setDirtyEditPinsFlagReduxStateAction(true))
   logAction('Move unviewable pins');

   var svg = evt.target.ownerSVGElement;
   var pins = svg.querySelectorAll('.pin');
   _.forEach(pins, function (pin) {
      if (pinOutsideImageView(pin,hole)) {
         var marker = pin.getAttribute('data-marker');
         svg.removeChild(pin);
         pin = createPin({ Name: marker, Latitude: 0, Longitude: 0, X: greenImageSize + 20, Y: 20 }, null, svg, hole);
         updatePin(pin,hole);
      }
   });

   var button = svg.querySelectorAll('.returnPins');
   if (button.length === 1) $(button[0]).remove();

   updateElements(svg,hole);
};

export function pinInBoundary(el,hole) {
   let coords = pinLocation(el,hole);
   return ((hole.left <= coords.x && coords.x <= hole.right) && (hole.back <= coords.y && coords.y <= hole.front));
}

function updateArrows(el,hole) {
   $(getSvg(el).querySelectorAll('.pinMeasurement')).remove();
   if (!pinInTray(el,hole)) createpinMeasurements(el, hole);
}

export function updateElements(svg, hole) {  
   let state = store.getState();
   let greensDescriptions = state.commonReducers.greensWithPinPlacementStateData
   let viewGrid = state.firstReducer.viewGridsReduxState
   let viewMeasurement = state.firstReducer.viewMeasurementReduxState
   let viewMeasureFromReduxState = state.firstReducer.viewMeasureFromReduxState;
   let viewActivePins = state.firstReducer.activeOnlyReduxState;
   let selectedMeasurementPin = state?.secondReduces?.selectedMeasurementPinReduxState?.toString();
   let activePinChecker = state?.secondReduces?.activeMeasurementPin
   let apiActivePinGetter = state?.secondReduces?.selectedMeasurementPinBackupReduxState
   let active = activeRotation();
   activeMarker = selectedMeasurementPin !== "" ? selectedMeasurementPin : active !== null && Object.keys(active).length !== 0 ? active.Marker : "cog"
   let parentRotation = getParentRotationSetForMarker(activeMarker,greensDescriptions);
  
   if ((activeMarker !== "") && ((parentRotation !== undefined) || !centerOfGreenActive())) {
      
      let activePinPlaced = false;
      let trayPosition = 1;
      let daily = (!centerOfGreenActive()) && parentRotation?.Type === "Daily";

      // Reset elements
      _.forEach(svg.querySelectorAll('.measurementPin'), function (pin) { removeClassSvg(pin, 'measurementPin'); });
      _.forEach(svg.querySelectorAll('.activePin'), function (pin) { removeClassSvg(pin, 'activePin'); });
      _.forEach(svg.querySelectorAll('.disabledPin'), function (pin) { removeClassSvg(pin, 'disabledPin'); });
      _.forEach(svg.querySelectorAll('.pin.hide'), function (pin) { removeClassSvg(pin, 'hide'); });
      _.forEach(svg.querySelectorAll('.cog'), function (pin) { addClassSvg(pin, 'hide'); });
      _.forEach(svg.querySelectorAll('.greenboundary'), function (grid) {
         if (viewGrid) {
            removeClassSvg(grid, 'hide');
         } else {
            addClassSvg(grid, 'hide');
         }
      });
      $(svg.querySelectorAll('.pinMeasurement')).remove();
      $(svg.querySelectorAll('.returnPins')).remove();

      let overridePin = svg.querySelectorAll('.override');
      overridePin = (overridePin.length === 1) ? overridePin[0] : null;

      let pins = svg.querySelectorAll('.pin');

      let checkPinIsViewable = function (pin) {
         if (!isUserReadOnly) {
            if (pinOutsideImageView(pin,hole)) {
               var button = svg.querySelectorAll('.returnPins');
               if (button.length === 0) {
                  var group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                  setAttributes(group, {'class': 'returnPins', cursor: 'pointer'});
                  var btn = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
                  setAttributes(btn, { x: 10, y: greenImageSize-30, rx: 5, ry: 5, width: greenImageSize-20, height: 22, fill: 'grey' });
                  group.appendChild(btn);
                  var t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                  setAttributes(t, { x: greenImageSize/2, y: greenImageSize-15, 'text-anchor': 'middle' });
                  t.textContent = 'Return out of view pins to tray';
                  group.appendChild(t);

                  group.addEventListener("mousedown",  function(e){
                     moveUnviewablePinsToTray(e,hole)
                  } , false);
               }
            }
         }
      };
      
      // console.log("holeMarkerDatayy1",hole)
      _.forEach(pins, function (pin) {
         let marker = pin.getAttribute('data-marker');

         //If pin is in tray, snap to correct position.
         if (pinInTray(pin,hole)) {
            // If this is the override pin, we have to refresh the pointer used in testing.
            if (marker === "*") overridePin = pin;

            pin.addEventListener("mousedown", function(evt){
               selectElement(evt,hole)
            }, false);
            pin.addEventListener("touchstart", function(evt){
               selectElement(evt,hole)
            }, false);
         } else {
          //Check to see if pin is not viewable.  Turn on return button when not viewable.
            checkPinIsViewable(pin);
         }
         
         if (viewMeasurement && (marker === selectedMeasurementPin)) {
            addClassSvg(pin, 'measurementPin');
            if (pinInBoundary(pin,hole)) {
               // Set arrows to point at selected pin
               
               // TODO -- Pending "updateArrows"
               updateArrows(pin,hole);
               activePinPlaced = true;
            }
            if (selectedMeasurementPin === activeMarker && activePinChecker) {
               addClassSvg(pin, 'activePin');
            }else{
               if(selectedMeasurementPin === apiActivePinGetter?.toString()){
                  addClassSvg(pin, 'activePin');
               }else{
                  addClassSvg(pin, '');
               }
            }
         } else if (viewMeasurement) {
            addClassSvg(pin, 'hide');
         } else if (marker === activeMarker?.toString() && !(daily && (overridePin !== null) && (!pinInTray(overridePin,hole)))) {
            addClassSvg(pin, 'activePin');
            if (!pinInTray(pin,hole)) activePinPlaced = true;
         } else if ((marker === "*") && (!daily)) {
            if (viewActivePins) {
               addClassSvg(pin, 'hide');
            } else {
               addClassSvg(pin, 'disabledPin');
            }
         } else if ((marker === "*") && (!pinInTray(pin,hole))) {
            addClassSvg(pin, 'activePin');
            activePinPlaced = true;
         } else if (viewActivePins) {
            addClassSvg(pin, 'hide');
         }
      });

      // Detemine if cog should be displayed.
      let cog = svg.querySelectorAll('image')[0];
      if (viewMeasurement && (viewMeasureFromReduxState === measureFromEnum.center)) {
         removeClassSvg(cog, 'hide');
      } else if (activeMarker === 'cog' || !activePinPlaced) {
         removeClassSvg(cog, 'hide');
      }
   }
};

export function removeClassSvg(el, cl) {
   if (el !== undefined) {
      let re = new RegExp("(?:^|\\s)" + cl + "(?!\\S)", "g");
      let cur = el.getAttribute("class");
      el.setAttribute("class", cur.replace(re, ''));
   }
}

 // Create arrow measurements elements for this hole.
 function createpinMeasurements(element, hole) {
   
   let state = store.getState();
   let viewMeasurement = state?.firstReducer?.viewMeasurementReduxState
   let selectedMeasurementPin = state?.secondReduces?.selectedMeasurementPinReduxState?.toString()
   if (viewMeasurement) {
      let measurePin = (_.filter(hole.UpdatedPinData, { Name: selectedMeasurementPin }));
      if (measurePin.length === 1) {
         measurePin = measurePin[0];
         let pinCoordinates = { x: measurePin.X, y: measurePin.Y };
         if (measurePin.transformed === undefined) {
            let coords = hole.viewToGreen.transformPoint(measurePin.X, measurePin.Y);
            pinCoordinates = { x: coords[0], y: coords[1] };
         }

         let def = defineArrows(pinCoordinates, hole);
         createArrow(def.horizontal, 'horizontal');
         createArrowDistance(def.horizontalCoord);
         createArrow(def.vertical, 'vertical');
         createArrowDistance(def.verticalCoord);
      }
   }

   function createArrowDistance(coords) {
      let state = store.getState();
      let viewMeasurement = state.firstReducer.viewMeasurementReduxState
      let formatText = {
         "text-anchor": "middle",
         "stroke-width": 1,
         "background-color": "white"
      };

      // Cap measurement box coordinates to be within the view area
      coords.x = Math.min(Math.max(coords.x, 10), greenImageSize - 10);
      coords.y = Math.min(Math.max(coords.y, 15), greenImageSize - 5);


      let group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      addClassSvg(group, 'pinMeasurement');
      if (!viewMeasurement) addClassSvg(group, 'hide'); //'onlyPrint');

      let textBox = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      setAttributes(textBox, {
         fill: 'white',
         width: 22,
         height: 20,
         x: coords.x - 11,
         y: coords.y - 15,
         rx: 5,
         ry: 5,
         stroke: 'black',
         'stoke-width': 1
      });
      group.appendChild(textBox);

      let t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      setAttributes(t, $.extend(formatText, coords));
      t.textContent = coords.dist;
      t.setAttributeNS(null, "pointer-events", "none");
      group.appendChild(t);

      getSvg(element).appendChild(group);
   }

   function createArrow(path, type) {
      // Default format and path of hidden arrow.
      let formatArrow = {
         d: "M-5,-5 l0,0",
         stroke: "#0000cc",
         'stroke-width': '1',
         'fill': 'none',
         'marker-end': 'url(#markerArrow)',
         'class': 'pinMeasurement'
      };

      if (path !== null) {
         $.extend(formatArrow, { d: path });
      }

      let arrow = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      setAttributes(arrow, formatArrow);
      addClassSvg(arrow, type);
      if (!viewMeasurement) addClassSvg(arrow, 'hide'); //'onlyPrint');
      getSvg(element).appendChild(arrow);
   }
}

function defineArrows(pinCoordinates, hole) {
   // console.log("defineArrows")
   let state = store.getState();
   let viewMeasureFrom = state.firstReducer.viewMeasureFromReduxState
   // Get the cog in Green Coordinate system
   let cog = hole.cog;
   let distanceValues = createDistanceMeasurements(pinCoordinates.x, pinCoordinates.y, hole);
   // console.log("distanceValuesData",pinCoordinates,hole)
   let rtn = { horizontal: "M-5,-5 l0,0", vertical: "M-5,-5 l0,0" };

   switch (viewMeasureFrom) {
      case measureFromEnum.frontClosest:
         if (distanceValues.dFromLeft < distanceValues.dFromRight) {
            rtn.horizontal = concatPath(hole.left, pinCoordinates.y, pinCoordinates.x - hole.left - 15, 0);
            rtn.horizontalCoord = { x: hole.left - 12, y: pinCoordinates.y + 5, dist: distanceValues.dFromLeft };
         } else {
            rtn.horizontal = concatPath(hole.right, pinCoordinates.y, pinCoordinates.x - hole.right + 15, 0);
            rtn.horizontalCoord = { x: hole.right + 12, y: pinCoordinates.y + 5, dist: distanceValues.dFromRight };
         }
         rtn.vertical = concatPath(pinCoordinates.x, hole.front, 0, pinCoordinates.y - hole.front + 15);
         rtn.verticalCoord = { x: pinCoordinates.x, y: hole.front + 15, dist: distanceValues.dFromFront };
         break;
      case measureFromEnum.closest:
         if (distanceValues.dFromLeft < distanceValues.dFromRight) {
            rtn.horizontal = concatPath(hole.left, pinCoordinates.y, pinCoordinates.x - hole.left - 15, 0);
            rtn.horizontalCoord = { x: hole.left - 12, y: pinCoordinates.y + 5, dist: distanceValues.dFromLeft };
         } else {
            rtn.horizontal = concatPath(hole.right, pinCoordinates.y, pinCoordinates.x - hole.right + 15, 0);
            rtn.horizontalCoord = { x: hole.right + 12, y: pinCoordinates.y + 5, dist: distanceValues.dFromRight };
         }
         if (distanceValues.dFromBack < distanceValues.dFromFront) {
            rtn.vertical = concatPath(pinCoordinates.x, hole.back, 0, pinCoordinates.y - hole.back - 15);
            rtn.verticalCoord = { x: pinCoordinates.x, y: hole.back - 5, dist: distanceValues.dFromBack };
         } else {
            rtn.vertical = concatPath(pinCoordinates.x, hole.front, 0, pinCoordinates.y - hole.front + 15);
            rtn.verticalCoord = { x: pinCoordinates.x, y: hole.front + 15, dist: distanceValues.dFromFront };
         }
         break;
      case measureFromEnum.frontLeft:
         rtn.horizontal = concatPath(hole.left, pinCoordinates.y, pinCoordinates.x - hole.left - 15, 0);
         rtn.horizontalCoord = { x: hole.left - 12, y: pinCoordinates.y + 5, dist: distanceValues.dFromLeft };
         rtn.vertical = concatPath(pinCoordinates.x, hole.front, 0, pinCoordinates.y - hole.front + 15);
         rtn.verticalCoord = { x: pinCoordinates.x, y: hole.front + 15, dist: distanceValues.dFromFront };
         break;
      case measureFromEnum.center:
         rtn.horizontal = concatPath(cog.x, cog.y, pinCoordinates.x - cog.x, 0);
         rtn.horizontalCoord = { x: pinCoordinates.x, y: (pinCoordinates.y > cog.y) ? cog.y - 10 : cog.y + 20, dist: distanceValues.dFromCogHorz };
         rtn.vertical = concatPath(cog.x, cog.y, 0, pinCoordinates.y - cog.y);
         rtn.verticalCoord = { x: (pinCoordinates.x > cog.x) ? cog.x - 15 : cog.x + 15, y: pinCoordinates.y, dist: distanceValues.dFromCogVert };
         break;
      default:
         break;
   }

   function concatPath(startx, starty, lengthx, lengthy) {
      return "M" + startx + "," + starty + " l" + lengthx + "," + lengthy;
   }
   // console.log("pinsArrowData",rtn)
   return rtn;
}

// TODO -- Methods under Process 
export const saveCourseRotationSets = () => {
   let state = store.getState()
   let { appDataReduxState:{courseNumber}, siteIdData } = state.firstReducer;   
   let courseRotationSets = createCourseRotationSets();   

   datacontext.saveCourseRotationSetsData(courseRotationSets,logActions.join(', ')); // Can use then here
   store.dispatch(COMMON_SERVICES.getGreensWithPinPlacementsServices(siteIdData,courseNumber)).then(() => {
      logActions = [];
      UpdatedApproachViews = [];
   })
   // After completion API call empty logAction, empty UpdatedApproachViews and Recall the API / Reload the page.
}

function createCourseRotationSets() {
   const state = store.getState();
   let crs = {};
   let gd = state.commonReducers.greensWithPinPlacementStateData;
   crs.Version = gd.Version;
   crs.Course = gd.Course;
   crs.IsOneDayOverride = gd.IsOneDayOverride;
   crs.RotationSets = [];   
   createRotationSets(gd, crs, rotationSetType.Daily.name);
   createRotationSets(gd, crs, rotationSetType.Special.name);
   return crs;
}

function checkActive(rotation,measurementPin){
   if(rotation.Type === "Special"){
      if(rotation.UserFigure === measurementPin){
         return true
      }else{
         return false
      }
   }else if(rotation.Type === "Daily"){
      let markersData = rotation && rotation?.Rotations.length !== 0 ? rotation?.Rotations.map((item) => item?.Marker) : [];
      if(markersData && markersData.length !== 0 && markersData.includes(measurementPin)){
         return true
      }else{
         return false
      }
   }
}

function createRotationSets(gd, crs, rotationSetTypeName) {
   _(_.filter(gd.RotationSets, { 'Type': rotationSetTypeName })).forEach(function (rotationSet) {
      var rs = {};
      rs.Course = gd.Course;
      // const { selectedMeasurementPinReduxState } = store.getState().firstReducer; TODO -- Changed Line
      const { selectedMeasurementPinReduxState } = store.getState().secondReduces;
      
      // TODO: This needs to be kept track of at each change of a Daily Play Rotation
      // rs.CurrentRotation = Number(selectedMeasurementPinReduxState);
      // rs.IsActive = rotationSet.ActiveSet;
      // rs.CurrentRotation = rotationSet.CurrentRotation;
      rs.CurrentRotation = rotationSet.Type === "Daily" ? Number(selectedMeasurementPinReduxState) : rotationSet.CurrentRotation
      rs.IsActive = checkActive(rotationSet,selectedMeasurementPinReduxState.toString());  
      rs.FirstHole = rotationSet.FirstHole;
      rs.LastHole = rotationSet.LastHole;
      rs.Name = rotationSet.Name;
      rs.RotationSetType = rotationSet.RotationSetType;
      rs.PinCharacter = rotationSet.UserFigure;
      createTodayRotation(gd,crs, rs);

      rs.Rotations = [];
      for (let j = 0; j < rotationSet.Rotations.length; j++) {
         (function (rotationIndex) {
            let rotation = rotationSet.Rotations[rotationIndex];
            createRotationPinPlacements(gd, rs, rotation,
               rotationSet.RotationSetType === rotationSetType.Daily.value ? rotation.RotationNumber.toString() : rotationSet.UserFigure);
         })(j);
      }

      crs.RotationSets.push(rs);
   });
}

function createTodayRotation(gd,crs, rotationSet) {
   let oneDayRotation = null;
   // We will only create the one day rotation if oneDayOverride is true and we are currently 
   // creation the daily rotation set.
   if (crs.IsOneDayOverride && rotationSet.RotationSetType === rotationSetType.Daily.value) {
      oneDayRotation = {};
      oneDayRotation.RotationNumber = 1;
      oneDayRotation.RotationType = rotationType.TodayOnly.value;
      createRotationPinPlacements(gd, rotationSet, oneDayRotation, '*');
   }
}

function createRotationPinPlacements(gd, rotationSet, rotation, name) {
   var aRotation = {};
   aRotation.RotationNumber = rotation.RotationNumber;
   aRotation.RotationType = rotation.RotationType;
   aRotation.PinPlacements = [];
   for (let k = 0; k < gd?.ApproachViews?.length; k++) {
       let approachView = gd.ApproachViews[k];
       var updatedApproachView = UpdatedApproachViews.filter((item) => item.Hole === approachView.Hole)
         if(updatedApproachView.length > 0){
            _(_.filter(updatedApproachView[0].UpdatedPinData, { 'Name': name })).forEach(function (pinPlacement) {
               let placement = {};
               placement.Usage = rotation.RotationType === rotationType.TodayOnly.value ? usageType.TodayOnly.value : usageType.Regular.value;
               placement.DateCreatedInUtc = (pinPlacement.X > 0 && pinPlacement.Y > 0) ? moment.utc() : moment(0);
               placement.Hole = approachView.Hole;
               placement.Latitude = pinPlacement.Latitude;
               placement.Longitude = pinPlacement.Longitude;
               placement.X = Math.round(pinPlacement.X);
               placement.Y = Math.round(pinPlacement.Y);
               aRotation.PinPlacements.push(placement);
            });
         }else{
            _(_.filter(approachView.PinPlacements, { 'Name': name })).forEach(function (pinPlacement) {
               let placement = {};
               placement.Usage = rotation.RotationType === rotationType.TodayOnly.value ? usageType.TodayOnly.value : usageType.Regular.value;
               placement.DateCreatedInUtc = (pinPlacement.X > 0 && pinPlacement.Y > 0) ? moment.utc() : moment(0);
               placement.Hole = approachView.Hole;
               placement.Latitude = pinPlacement.Latitude;
               placement.Longitude = pinPlacement.Longitude;
               placement.X = Math.round(pinPlacement.X);
               placement.Y = Math.round(pinPlacement.Y);
               aRotation.PinPlacements.push(placement);
            });
         }
   }
   if (rotation.RotationType === rotationType.TodayOnly.value) {
      rotationSet.TodayRotation = aRotation;
   } else {
      rotationSet.Rotations.push(aRotation);
   }
}